import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { LinkCodesActionWire } from '../types';
import { ListAction } from '../types-store';

export const mapActionsToWire = (actions: ListAction[]): LinkCodesActionWire[] =>
  actions?.map(action => ({
    codeId: action.path[action.path.length - 1],
    applyOnDescendants: action.propagate,
    action: action.type,
    ...(isDefinedIncludingZero(action.category) && { category: action.category })
  })) ?? [];
